import { NFLookupCatalog } from "./NFLookupCatalog";
import { AppEntities } from "../../../config/entities";
import { NFLookupCatalogColumn } from "./NFLookupCatalogColumn";
import React from "react";

interface IProps {
  title?: string;
  fieldName: string;
  required?: boolean;
  showBorder?: boolean;
  accountId?: string;
  selectedCatalog?: boolean;
  setSelectedCatalog?: (value: boolean) => void;
  searchText?: string;
  setSearchText?: React.Dispatch<React.SetStateAction<string>>;
  onChange?: (e: any) => void;
  value?: any;
  onBlur?: () => void;
}

export const NFLookupCompany = ({
  title,
  fieldName,
  required,
  showBorder,
  selectedCatalog,
  setSelectedCatalog,
  searchText,
  setSearchText,
  onChange,
  value,
  onBlur,
}: IProps) => {
  const loadData = async (searchText: string | undefined) => {
    return await AppEntities.Company.getDataService().GetAll(searchText);
  };

  return (
    <>
      <NFLookupCatalog
        fieldName={fieldName}
        title={title}
        entity={AppEntities.Company}
        serverData={loadData}
        required={required}
        showBorder={showBorder}
        selectedCatalog={selectedCatalog}
        setSelectedCatalog={setSelectedCatalog}
        // searchText={searchText}
        // setSearchText={setSearchText}
      >
        <NFLookupCatalogColumn fieldName={"id"} caption={"Id"} />
        <NFLookupCatalogColumn fieldName={"name"} caption={"Name"} />
        <NFLookupCatalogColumn fieldName={"tin"} caption={"TIN"} />
      </NFLookupCatalog>
    </>
  );
};
